import { api } from "@/lib/api";
import type { BlockDetail, BlockSummary } from "./types";

export const blocksApi = {
  list: (params: { category?: string; search?: string } = {}) => {
    const query = new URLSearchParams();
    if (params.category) query.set("category", params.category);
    if (params.search) query.set("search", params.search);
    const suffix = query.toString();
    return api.get<BlockSummary[]>(`/blocks${suffix ? `?${suffix}` : ""}`);
  },
  get: (slug: string) => api.get<BlockDetail>(`/blocks/${slug}`),
  categories: () => api.get<string[]>("/blocks/categories"),
};

/** Image URL for a block. Served by the API straight from the registry
 *  directory, so there is no build step copying artwork into the bundle. */
export const blockImageUrl = (slug: string) => `/api/v1/blocks/${slug}/image`;

export const blockKeys = {
  all: ["blocks"] as const,
  lists: () => [...blockKeys.all, "list"] as const,
  list: (category: string, search: string) =>
    [...blockKeys.lists(), { category, search }] as const,
  detail: (slug: string) => [...blockKeys.all, "detail", slug] as const,
  categories: () => [...blockKeys.all, "categories"] as const,
};
